module.exports = __webpack_public_path__ + "static/media/united_card_5.3d348b18.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/LargeFlightCard/images/united_card_5.jpg
// module id = 526
// module chunks = 0